if (!customElements.get('cw-product-views')) {
  customElements.define('cw-product-views', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const button = this.querySelector('.cw-views__toggle');
      const link = this.querySelector('.cw-views__link');
      const first = this.querySelector('.cw-views__face--primary');
      const second = this.querySelector('.cw-views__face--secondary');
      const label = this.querySelector('[data-view-label]');
      if (!button || !link || !first || !second || !label) return;
      const title = link.getAttribute('aria-label');
      const set = flipped => {
        this.classList.toggle('is-flipped', flipped);
        const action = flipped ? this.dataset.primary : this.dataset.secondary;
        button.setAttribute('aria-pressed', String(flipped));
        button.setAttribute('aria-label', `${action}: ${title}`);
        label.textContent = action;
        first.setAttribute('aria-hidden', String(flipped));
        second.setAttribute('aria-hidden', String(!flipped));
      };
      const fine = () => matchMedia('(hover: hover) and (pointer: fine)').matches;
      link.addEventListener('pointerenter', () => { if (fine()) set(true); });
      this.addEventListener('pointerleave', () => { if (fine()) set(false); });
      button.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        set(!this.classList.contains('is-flipped'));
      });
      link.addEventListener('click', event => {
        if (fine()) return;
        event.preventDefault();
        event.stopPropagation();
        set(!this.classList.contains('is-flipped'));
      });
    }
  });
}
